import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { FormsModule } from "@angular/forms";

//modules
import { SharedModule } from "../shared/shared.module";

//components
import { UserCourseComponent } from "./components/user-course/user-course.component";
import { UserHomeComponent } from "./components/user-home/user-home.component";
import { UserStepAssessmentComponent } from "./components/user-step-assessment/user-step-assessment.component";
import { UserStepTlaComponent } from "./components/user-step-tla/user-step-tla.component";
import { UserStepCourseOutcomeComponent } from "./components/user-step-course-outcome/user-step-course-outcome.component";
import { UserStepMappingComponent } from "./components/user-step-mapping/user-step-mapping.component";
import { UserStepCourseQuestionComponent } from "./components/user-step-course-question/user-step-course-question.component";
import { UserStepSummaryComponent } from "./components/user-step-summary/user-step-summary.component";
import { UserStepSummaryCourseQuestionComponent } from "./components/user-step-summary-course-question/user-step-summary-course-question.component";
import { UserStepCourseOutcomeDetailsComponent } from "./components/user-step-course-outcome-details/user-step-course-outcome-details.component";

const routes: Routes = [
  { path: "", component: UserHomeComponent, pathMatch: "full" },
  {
    path: "courses/:courseId/:stepName",
    component: UserCourseComponent
  },
  {
    path: "courses/:courseId",
    component: UserCourseComponent
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    UserHomeComponent,
    UserCourseComponent,
    UserStepAssessmentComponent,
    UserStepTlaComponent,
    UserStepCourseOutcomeComponent,
    UserStepMappingComponent,
    UserStepCourseQuestionComponent,
    UserStepSummaryComponent,
    UserStepSummaryCourseQuestionComponent,
    UserStepCourseOutcomeDetailsComponent
  ],
  providers: []
})
export class UserModule {}
